import { useEffect, useState } from "react";

const STORAGE_KEY = "ziolo.cookie-ok";

function alreadyAccepted(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    // Private mode can throw. Still show the bar; accept() hides it for this visit.
    return false;
  }
}

/**
 * Notice for first-party functional cookies. There is no reject path: the cookies
 * are required for login and anonymous Wordle, and nothing is used for ads.
 */
export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(!alreadyAccepted());
  }, []);

  useEffect(() => {
    document.body.classList.toggle("z-has-cookie-banner", visible);
    return () => document.body.classList.remove("z-has-cookie-banner");
  }, [visible]);

  if (!visible) return null;

  function accept() {
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch {
      // Ignore: the bar just stays gone for this visit.
    }
    setVisible(false);
  }

  return (
    <div className="z-cookie" role="dialog" aria-label="Informacja o ciasteczkach">
      <p className="z-cookie__text">
        Używamy dwóch ciasteczek funkcjonalnych: sesji po zalogowaniu oraz gościa
        Wordle. Nie ma reklam ani analityki. Szczegóły w{" "}
        <a href="/polityka-cookies">polityce cookies</a>.
      </p>
      <button type="button" className="z-btn z-btn--primary z-cookie__ok" onClick={accept}>
        Rozumiem
      </button>
    </div>
  );
}
